import c from "./utils/constants";

class AppController {
  constructor(NavigationService, FilterService) {
    "ngInject"

    this.navigationService = NavigationService;
    this.filterService = FilterService;
    // this.getGlobaFilterOptions();
  }

  $onInit() {
  }


  hideNav() {
    return this.navigationService.isCurrent("login");
  }

  hideGlobalFilters() {
    // return !this.navigationService.isCurrent("users");
    return false;
  }

  getGlobalFilterOptions() {
    let filterOptions;

    if(this.navigationService.isCurrent(c.screens.USERS)) {
      filterOptions = this.filterService.getGlobalUsersFilterOptions();
    } else if(this.navigationService.isCurrent(c.screens.JOBS)) {
      filterOptions = this.filterService.getGlobalJobsFilterOptions();
    } else if(this.navigationService.isCurrent(c.screens.JOB_REQUESTS)) {
      filterOptions = this.filterService.getGlobalJobRequestsFilterOptions();
    } else if(this.navigationService.isCurrent(c.screens.AFFILIATES)) {
      filterOptions = this.filterService.getGlobalAffiliatesFilterOptions();
    } else if(this.navigationService.isCurrent(c.screens.CERTIFICATES)) {
      filterOptions = this.filterService.getGlobalCertificatesFilterOptions();
    } else if(this.navigationService.isCurrent(c.screens.CHECKS)) {
      filterOptions = this.filterService.getGlobalCheckssFilterOptions();
    } else if (this.navigationService.isCurrent(c.screens.BOT_MANAGER)) {
      filterOptions = this.filterService.getGlobalBotManagerFilterOptions();
    } else if (this.navigationService.isCurrent(c.screens.BOT_SESSIONS)) {
      filterOptions = this.filterService.getGlobalBotSessionsFilterOptions();
    } else if (this.navigationService.isCurrent(c.screens.VOUCHES)) {
      filterOptions = this.filterService.getGlobalVocuhesFilterOptions();
    } else if(this.navigationService.isCurrent(c.screens.BUSINESSES)) {
      filterOptions = this.filterService.getGlobalBusinessesFilterOptions();
    }

    return filterOptions;
  }


}

export default AppController;



/** WEBPACK FOOTER **
 ** E:/JUGGLE_STREET/Juggle-Street-Deployment-All/JSBIGFOOTFRONTEND-BACKEND/admin-frontend/client/app/app.controller.js
 **/